import Localize from 'react-intl-universal';

import { getBaseTEMUrl } from '@services/baseService';

let browserLanguage = navigator.language || (navigator.languages && navigator.languages[0]);

if (!browserLanguage) {
  browserLanguage = 'en-US';
}

export const getHomePageText = (homePageData = []) => {
  const lang = (navigator.language || 'en').split('-')[0];

  const primaryKey =
    lang === 'de' ? 'home.page.description.field.german' : 'home.page.description.field.english';

  const fallbackKey =
    primaryKey === 'home.page.description.field.german'
      ? 'home.page.description.field.english'
      : 'home.page.description.field.german';

  let item = homePageData.find((data) => data.key === primaryKey);

  if (!item || !item.value?.length) {
    item = homePageData.find((data) => data.key === fallbackKey);
  }

  let value = item?.value;

  if (!value || (Array.isArray(value) && value.length === 0)) {
    value = Localize.get('EventDetails.noTopics');
  }

  if (typeof value === 'string') {
    return [
      {
        type: 'paragraph',
        children: [{ text: value }]
      }
    ];
  }

  return value;
};

export const getHomePagePlainText = (homePageData = []) => {
  const value = getHomePageText(homePageData);

  const hasContent =
    Array.isArray(value) && value.some((block) => block?.children?.some((c) => c?.text?.trim()));

  if (!hasContent) {
    return Localize.get('EventDetails.noTopics');
  }

  return value
    .map((block) => block?.children?.map((c) => c?.text || '').join(''))
    .filter((text) => text.trim() !== '')
    .join('\n');
};

const getLocalizedValue = (news, engField, deField) => {
  switch (browserLanguage) {
    case 'en':
    case 'en-US':
      return news?.[engField];
    case 'de':
      return news?.[deField];
    default:
      return Localize.get('EventDetails.noTopics');
  }
};

export const readNewsHeader = (news) => getLocalizedValue(news, 'nameEng', 'nameDe');

export const readNewsDescription = (news) =>
  getLocalizedValue(news, 'shortDescriptionEng', 'shortDescriptionDe');

export const readNewsDescriptionJSON = (news) =>
  getLocalizedValue(news, 'descriptionEng', 'descriptionDe');

export const newsImagethumbnailUrl = (news, memoizedImageSource) => {
  if (news?.catalogPicture?.thumbnailUrl) {
    return `${getBaseTEMUrl()}customer-consents/${news?.uuid}/thumbnails/catalog-pictures`;
  }
  return memoizedImageSource || '';
};

export const newsImageUrl = (news, memoizedImageSource) => {
  if (news?.catalogPicture?.url) {
    return `${getBaseTEMUrl()}customer-consents/${news?.uuid}/catalog-pictures`;
  }
  return memoizedImageSource || '';
};
